import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

export default function ModalReturnProductSuccess({ modalOpenObj, returnResponse, onStartNewSale, ...props }) {
  const handleStartNewSale = () => {
    if (onStartNewSale) {
      onStartNewSale();
    }
    modalOpenObj.setModalOpen(false);
  };

  if (!returnResponse) {
    return null;
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={handleStartNewSale}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white position-relative focus-visible-none w-[min(90.11vw,905px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)]">
            <div className="text-end absolute top-[10px] right-[10px]">
              <button className="btn btn-close-modal" onClick={handleStartNewSale}></button>
            </div>
            <div className="p-[min(2.74vw,25px)]">
              <div className="mb-4 pb-2">
                <div className="d-flex align-items-center">
                  <div className="icon-succes-st-1 me-3"></div>
                  <div className="text-[#2DC76D] fw-bold fs-24">การคืนสินค้าเสร็จสิ้น</div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <div className="p-3" style={{ borderRadius: '15px', background: '#F4FCF8' }}>
                    <div className="d-flex tq-1 mb-4">
                      <div className="align-self-center me-auto text-[#2DC76D] fw-bold">ข้อมูลลูกค้า</div>
                      <img
                        className="aspect-square w-[min(6.13vw,62px)] rounded-full object-cover"
                        src={'/img/avatar-female.png'}
                        alt=""
                      />
                    </div>
                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div className="">ชื่อลูกค้า</div>
                      <div className="">
                        {returnResponse?.member
                          ? `${returnResponse?.member?.first_name_th} ${returnResponse?.member?.last_name_th}`
                          : '-'}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div className="">แต้มสะสมที่มีอยู่</div>
                      <div className="fw-light">{returnResponse?.totalPointBeforDeduct || '0'}</div>
                    </div>
                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div className="">ใช้แต้มสะสมไป</div>
                      <div className="fw-light">
                        {Number(returnResponse?.points_returned || 0) > 0 ? `-${returnResponse?.points_returned}` : '0'}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mb-3 text-[#2F4858] fs-18">
                      <div className="">
                        <span className="icon-star"></span> แต้มสะสมคงเหลือ
                      </div>
                      <div className="text-[#2DC76D] fw-bold">{returnResponse?.totalPointAfterDeduct || '0'}</div>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="d-flex mb-2">
                    <div className="align-self-center fw-500 text-[#061126] fs-18">รายละเอียดการคืนเงิน</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">เลขที่ใบเสร็จ</div>
                    <div className="fs-18 text-[#2F4858]">{returnResponse?.receipt_no || '-'}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">เลขที่ใบคืนเงิน</div>
                    <div className="fs-18 text-[#2F4858]">{returnResponse?.refund_no || '-'}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">ช่องทางการคืนเงิน</div>
                    <div className="fs-18 text-[#2F4858]">{returnResponse?.refund_payment_method?.name || '-'}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">ราคาทั้งหมด</div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      -<span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">ส่วนลดทั้งหมด</div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      -<span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">ราคาสุทธิ</div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      -<span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <div className="fs-18 fw-light text-[#2F4858]">จำนวนที่ชำระ</div>
                    <div className="fs-24 fw-500 text-[#2F4858]">
                      -<span className="fs-18 fw-500 ms-4">THB</span>
                    </div>
                  </div>

                  <hr className="line-st1 my-3" style={{ opacity: 0.8 }} />
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text-[#2DC76D] fs-24 fw-bold">จำนวนเงินที่คืน</div>
                    <div className="d-flex align-items-center">
                      <div
                        className="text-[#2DC76D] fs-30 fw-bold px-5 py-1"
                        style={{
                          borderRadius: '8px',
                          background: 'rgba(45, 199, 109, 0.25)'
                        }}
                      >
                        {parseFloat(returnResponse?.refund_amount || returnResponse?.total_price || 0).toFixed(2)}
                      </div>
                      <span className="fs-18 fw-500 text-[#00BC3A] ms-4">THB</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="line-st1 mt-3 mb-0" style={{ opacity: 0.8 }} />
            <div className="d-flex justify-content-end p-4 my-2">
              <button className="btn btn-st4 me-3" onClick={() => {}} disabled>
                Print
              </button>
              <button className="btn btn-st5" onClick={handleStartNewSale}>
                เสร็จสิ้น
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
